



























import { Component, Vue } from 'vue-property-decorator'
import { ProjectIsGPT } from '@/utils/project'
import LocalizationServise from '../../services/localization'
@Component
export default class AppHeader extends Vue {
  changeLocale!: (any) => void
  locale = ''
  get isGpt() {
    return ProjectIsGPT()
  }

  changeLocaleHandler() {
    LocalizationServise.changeLocale(this.locale)
  }
  created() {
    this.locale = this.$i18n.locale
  }
}
